import { createResource, Show } from 'solid-js';

async function fetchJSON(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error('HTTP ' + res.status);
  return res.json();
}

export default function Dashboard() {
  const [health] = createResource(() => fetchJSON('/api/health'));
  const [sum] = createResource(() => fetchJSON('/api/dashboard'));

  // Card value: the live number once loaded, an em dash before/if absent.
  const val = (v) => (sum.loading ? '…' : v ?? '—');

  // "Gaji Diproses" hint names the completed cycle it counts, so the figure is
  // never confused with the current accruing period.
  const procHint = () => {
    const d = sum();
    if (!d || !d.hasData) return 'belum ada proses';
    return d.isCurrent ? 'periode berjalan' : d.lastDoneLabel;
  };
  const slipHint = () => {
    const d = sum();
    if (!d || !d.slipsTotal) return 'di portal karyawan';
    return `${d.slipPeriods} periode di portal`;
  };

  return (
    <>
      <div class="page-head">
        <h2>Ringkasan</h2>
        <div class="spacer" />
        <Show when={health()} fallback={<span class="badge warning">memeriksa…</span>}>
          <Show when={health().db === 'ok'} fallback={<span class="badge danger" title={health().db}>DB terputus</span>}>
            <span class="badge success">DB terhubung</span>
          </Show>
        </Show>
      </div>

      <div class="stat-grid">
        <div class="card stat">
          <div class="label">Karyawan Aktif</div>
          <div class="value">{val(sum()?.activeEmployees)}</div>
          <div class="hint">terdaftar &amp; aktif</div>
        </div>
        <div class="card stat">
          <div class="label">Periode Berjalan</div>
          <div class="value period">{sum.loading ? '…' : (sum()?.periodLabel ?? '—')}</div>
          <div class="hint">21 → 20 setiap bulan</div>
        </div>
        <div class="card stat">
          <div class="label">Gaji Diproses</div>
          <div class="value">{val(sum()?.processed)}</div>
          <div class="hint">{procHint()}</div>
        </div>
        <div class="card stat">
          <div class="label">Slip Tersedia</div>
          <div class="value">{val(sum()?.slipsTotal)}</div>
          <div class="hint">{slipHint()}</div>
        </div>
      </div>

      <div class="card card-pad" style="margin-top:14px">
        <div class="empty">
          <div>
            <div class="big">◫</div>
            <Show
              when={sum() && sum().hasData}
              fallback={<>Belum ada gaji yang diproses. Mulai dari <b>Absensi → Proses Gaji</b> untuk periode berjalan.</>}
            >
              Payroll terakhir yang selesai: <b>{sum().lastDoneLabel}</b> — {sum().processed} karyawan.
              {' '}{sum().slipsTotal} slip tersedia di portal karyawan.
            </Show>
          </div>
        </div>
      </div>
    </>
  );
}
